(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gs-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gs-image-gallery')) {
    customElements.define('gs-image-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.triggers = Array.from(this.querySelectorAll('[data-gallery-trigger]'));
        this.media = this.querySelector('[data-gallery-media]');
        this.caption = this.querySelector('[data-gallery-caption]');
        this.position = this.querySelector('[data-gallery-position]');
        this.status = this.querySelector('[data-gallery-status]');
        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-gallery-trigger]');
          if (trigger) {
            this.invoker = trigger;
            this.showImage(this.triggers.indexOf(trigger));
            if (!this.dialog.open) this.dialog.showModal();
            return;
          }
          if (event.target.closest('[data-gallery-close]')) this.dialog.close();
          if (event.target.closest('[data-gallery-previous]')) this.showImage(this.index - 1);
          if (event.target.closest('[data-gallery-next]')) this.showImage(this.index + 1);
          if (event.target === this.dialog) {
            const bounds = this.dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
          }
        }, options);
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'Tab') {
            const controls = Array.from(this.dialog.querySelectorAll('button:not(:disabled)'));
            const first = controls[0];
            const last = controls[controls.length - 1];
            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first.focus();
            }
          }
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showImage(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
          }
        }, options);
        this.dialog.addEventListener('close', () => {
          this.media.replaceChildren();
          this.image = null;
          this.status.textContent = '';
          if (this.invoker?.isConnected) this.invoker.focus({ preventScroll: true });
        }, options);
        this.querySelectorAll('[data-gallery-previous], [data-gallery-next]').forEach((control) => {
          control.disabled = this.triggers.length < 2;
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        if (this.dialog?.open) this.dialog.close();
      }
      showImage(index) {
        if (!this.triggers.length) return;
        this.index = (index + this.triggers.length) % this.triggers.length;
        const trigger = this.triggers[this.index];
        const image = document.createElement('img');
        this.image = image;
        image.alt = trigger.dataset.imageAlt;
        image.width = Number(trigger.dataset.imageWidth);
        image.height = Number(trigger.dataset.imageHeight);
        image.decoding = 'async';
        this.status.textContent = this.dataset.loadingLabel;
        image.addEventListener('load', () => {
          if (this.image === image) this.status.textContent = '';
        }, { once: true });
        image.addEventListener('error', () => {
          if (this.image === image) this.status.textContent = this.dataset.errorLabel;
        }, { once: true });
        image.src = trigger.dataset.imageUrl;
        this.media.replaceChildren(image);
        this.caption.textContent = trigger.dataset.imageTitle;
        this.position.textContent = this.dataset.positionLabel.replace('__CURRENT__', this.index + 1).replace('__TOTAL__', this.triggers.length);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
